import { Alert, Box, Button, Grid, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RkdCard from "../../app/component/card/RkdCard";
import Diagram from "../../app/component/features/diagram/Diagram";
import SystemTreeSelector from "../../app/component/features/SystemTreeSelector";
import { RKDSectionLoading } from "../../app/component/helper/RkdSectionLoading";
import useHeight from "../../app/hook/useHeight";
import { useStore } from "../../app/stores/store";

function RBDIndex() {
  const { commonStore, assetStore, rbdStore } = useStore();
  const { card: c, other: e, etc: o } = assetStore.elementsHeight;
  const { assetSetting } = assetStore;
  const navigate = useNavigate();
  const theme = useTheme();
  const { ref, height } = useHeight();

  useEffect(() => {
    commonStore.setTitlePage("Reliability Block Diagram (RBD)");
  });

  const handleSettingRBD = () => {
    navigate({
      pathname: `/rbd/setting/${assetSetting.type}/${assetSetting.id}`,
      search: commonStore.stationIdQuery ? `?stationId=${commonStore.stationIdQuery}` : "",
    });
  };

  useEffect(() => {
    assetStore.setCardHeight(height);
  }, [height, assetStore]);

  useEffect(() => {
    if (!assetSetting.id) return;
    if (!assetSetting.type) return;

    if (assetSetting.type === "station") {
      rbdStore.getStationDiagram(assetSetting.id);
      return;
    }

    if (assetSetting.type === "system") {
      rbdStore.getSystemDiagram(assetSetting.id);
      return;
    }
  }, [assetSetting, rbdStore]);

  return (
    <RkdCard ref={ref}>
      <Grid container spacing={2}>
        <Grid
          sx={{
            borderRight: `1px solid ${theme.palette.grey[200]}`,
            pr: 2,
          }}
          item
          xs={4}
        >
          <SystemTreeSelector isRbd />
        </Grid>
        <Grid item xs={8}>
          <Button
            disabled={assetSetting.id === null || assetSetting.type === null || assetSetting.type === "equipment"}
            variant="contained"
            color="primary"
            onClick={() => handleSettingRBD()}
          >
            Setting RBD
          </Button>
          <Box sx={{ mt: 2 }}>
            {rbdStore.loadingDiagram ? (
              <RKDSectionLoading />
            ) : rbdStore.displayDiagram ? (
              <Diagram styles={{ height: c - e - o - 10 }} />
            ) : (
              <Alert severity="info">There are no diagrams to display</Alert>
            )}
          </Box>
        </Grid>
      </Grid>
    </RkdCard>
  );
}

export default observer(RBDIndex);
